const CONTINUE_MESSAGE_MARKER_PATTERN =
  / ?\(please continue the message\)\.?/g;

export function removeContinueMessageMarkers(message) {
  return message.replace(CONTINUE_MESSAGE_MARKER_PATTERN, "");
}
